export function TelegramIcon({ className = '' }: { className?: string }) {
    return <div className={'bg-[image:var(--telegram-logo-svg)] bg-cover cursor-pointer ' + className} />;
}
